<div [ngClass]="{'appContainer-mobile': isMobile, 'appContainer-desktop' : !isMobile }" class="appContainer">
  <router-outlet></router-outlet>
</div>